module.exports = __webpack_public_path__ + "img/plus-symbol.c42a7ed2.png";